import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import descriptor from "./descriptor";
import options from './options';

const title = "PM Salesforce Sort Codes";
const urlData = "pmSfSortCodes";
const bulkName = "subheading.label";

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.propsList = {
      descriptor,
      exportImport: options.exportImportOptions,
    }
  }

  getModelName = () => 'pmsfsortcode'
}

class Detail extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = title
    this.urlData = urlData
    this.bulkName = bulkName
    this.fields = fields
    this.propsDetail = {
      // urlKeyHistory: 'api:admin:estimation:pmsfsortcode:detail-revision',
      keyLabel: 'description'
    }
  }
}

export default { List, Detail };